/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContratLieuxFormationGridDto } from './ContratLieuxFormationGridDto';
import {
    ContratLieuxFormationGridDtoFromJSON,
    ContratLieuxFormationGridDtoFromJSONTyped,
    ContratLieuxFormationGridDtoToJSON,
} from './ContratLieuxFormationGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContratLieuxFormationGridDtoPaginatedResults
 */
export interface ContratLieuxFormationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContratLieuxFormationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContratLieuxFormationGridDto>}
     * @memberof ContratLieuxFormationGridDtoPaginatedResults
     */
    results?: Array<ContratLieuxFormationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContratLieuxFormationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContratLieuxFormationGridDtoPaginatedResults interface.
 */
export function instanceOfContratLieuxFormationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratLieuxFormationGridDtoPaginatedResultsFromJSON(json: any): ContratLieuxFormationGridDtoPaginatedResults {
    return ContratLieuxFormationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContratLieuxFormationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratLieuxFormationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContratLieuxFormationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContratLieuxFormationGridDtoPaginatedResultsToJSON(value?: ContratLieuxFormationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContratLieuxFormationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

